/**
 * Mailbox providers anyone can sign up to. Verifying one of these as a test
 * allowlist domain would let a tenant send test mail to everyone on it, so
 * they can only be added as individually confirmed addresses.
 */
export const PUBLIC_MAIL_DOMAINS: ReadonlySet<string> = new Set([
  '163.com',
  'aol.com',
  'fastmail.com',
  'gmail.com',
  'gmx.com',
  'gmx.net',
  'googlemail.com',
  'hey.com',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'mail.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'pm.me',
  'proton.me',
  'protonmail.com',
  'qq.com',
  'yahoo.com',
  'yandex.com',
  'yandex.ru',
  'ymail.com',
  'zoho.com',
])
